'use client'

import { Button } from '@repo/ui/components'

import { useDateTimeInput } from './context.tsx'

//new component with 3 buttons next week, next month, not sure
export const QuickSelectDateInput = () => {
  const {
    dateState: [_, setDate],
    quickSelectState: [quick, setQuick],
    timeState: [_time, setTime],
  } = useDateTimeInput()

  const handleSelect = (type: 'next-month' | 'next-week' | 'not-sure') => {
    setTime({
      type: '24',
    })

    const date = new Date()
    switch (type) {
      case 'next-month':
        date.setMonth(date.getMonth() + 1)
        date.setDate(1)
        setDate(date)
        break
      case 'next-week':
        const daysUntilMonday = (8 - date.getDay()) % 7 || 7
        date.setDate(date.getDate() + daysUntilMonday)
        setDate(date)
        break
      case 'not-sure':
        setDate(undefined)
        break
      default:
        return
    }
    setQuick(type)
  }

  return (
    <div className={'flex w-full items-center justify-center gap-2 p-2'}>
      <Button
        onClick={() => handleSelect('next-week')}
        variant={quick === 'next-week' ? 'default' : 'outline'}
      >
        Next week
      </Button>
      <Button
        onClick={() => handleSelect('next-month')}
        variant={quick === 'next-month' ? 'default' : 'outline'}
      >
        Next month
      </Button>
      <Button
        onClick={() => handleSelect('not-sure')}
        variant={quick === 'not-sure' ? 'default' : 'outline'}
      >
        Not sure
      </Button>
    </div>
  )
}
